<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <AudienceHeader />
        <AudienceDetails />
    </AccountViewBase>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import { useAudienceStore } from '@/stores/audience';
    import { useScreenWidthStore } from '@/stores/utils/screenWidth';
    import { useApiCreditsStore } from '@/stores/apiCredits';
    import AudienceHeader from '@/components/audience/AudienceHeader';
    import AudienceDetails from '@/components/audience/AudienceDetails';

    export default {
        name: 'AudienceView',
        components: {
            AccountViewBase,
            AudienceHeader,
            AudienceDetails
        },
        mixins: [i18nViewMixin, accountMixin],
        props: {
            id: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                seo_title: 'views.audience.seo_title',
                seo_title_data: null
            };
        },
        computed: {
            ...mapState(useScreenWidthStore, ['hasMediumScreen']),
            ...mapState(useAudienceStore, {
                audience: 'audience',
                audienceLoading: 'loading'
            }),
            ...mapState(useApiCreditsStore, {
                creditsLoading: 'loading'
            }),
            loading() {
                return this.accountLoading || this.audienceLoading || this.creditsLoading;
            }
        },
        methods: {
            ...mapActions(useAudienceStore, ['getAudience']),
            ...mapActions(useApiCreditsStore, ['getApiCredits']),
            generateSeoTitle() {
                this.seo_title = 'views.audience.seo_title_audience';
                this.seo_title_data = {
                    name: this.audience?.name || '-'
                };
                this.updateDocumentTitle();
            },
            async updateAudience(id) {
                const result = await this.getAudience(id, this.$router, true);

                if (result) {
                    this.generateSeoTitle();
                }
            },
        },
        watch: {
            id: {
                async handler(newVal) {
                    if (newVal) {
                        await this.updateAudience(newVal);
                    }
                },
                immediate: true
            },
        },
        async mounted() {
            await this.getApiCredits();
        },
    }
</script>